// src/components/ImageGallery.tsx
import React, { useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import 'yet-another-react-lightbox/styles.css';

interface ImageGalleryProps {
  images: string[];
  className?: string;
}

const ImageGallery: React.FC<ImageGalleryProps> = ({
  images,
  className = "",
}) => {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);

  return (
    <>
      {/* Thumbnail Grid */}
      <div className={`grid grid-cols-2 md:grid-cols-3 gap-4 ${className}`}>
        {images.map((src, i) => (
          <button
            key={i}
            onClick={() => {
              setIndex(i);
              setOpen(true);
            }}
            className="rounded-3xl overflow-hidden shadow-xl aspect-[16/10] hover:scale-[1.02] transition-transform"
          >
            <img
              src={src}
              alt={`Gallery ${i + 1}`}
              className="w-full h-full object-cover"
            />
          </button>
        ))}
      </div>

      {/* Lightbox */}
      <Lightbox
        open={open}
        index={index}
        controller={{ closeOnBackdropClick: true }}
        close={() => setOpen(false)}
        slides={images.map((src) => ({ src }))}
      />
    </>
  );
};

export default ImageGallery;
